import { render, staticRenderFns } from "./TheNoticeBoard.vue?vue&type=template&id=aada1cc4&scoped=true&"
import script from "./TheNoticeBoard.vue?vue&type=script&lang=js&"
export * from "./TheNoticeBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aada1cc4",
  null
  
)

export default component.exports